module.exports = __webpack_public_path__ + "static/responsible-investments-desktop.bc94ae32.webp";